import { useState } from 'react';

import Button from '../../Ui/Button/Button';

import Modal from '../../Ui/Modal/Modal';

const FirstScreen = () => {

	const [modalActive, setModalActive] = useState(false);

	const modalText = 'это платформа, где есть студенты и есть учителя. Практикующие специалисты создают программу обучения и разбивают ее на небольшие курсы в виде пайплайна, в программе есть все что нужно знать начинающему специалисту';

	const buttonClickHandler = () => {
		setModalActive(true);
		document.body.style.paddingRight = '17px';
	}

	return (
		<div className="main__study study-main">
			<div className="study-main__circle"></div>
			<Modal active={modalActive} setActive={setModalActive} text={modalText} />
			<div className="study-main__body">
				<div className="study-main__info-box">
					<div className='study-main__info'>
						<h1 className="study-main__title">StudyPipe</h1>
						<div className="study-main__text">
							<p>— это платформа, где есть студенты и есть учителя. Практикующие специалисты создают программу обучения и разбивают ее на небольшие курсы в виде пайплайна, в программе есть все что нужно знать начинающему специалисту</p>
						</div>
						<div className='study-main__button-box' onClick={buttonClickHandler}>
							<Button variant={'green'} />
						</div>
					</div>
				</div>
				<div className="study-main__image-box">
					<div className="study-main__image">
						<img src="assets/images/mainPage/firstItem/desk.png" alt="" />
					</div>
				</div>
			</div>
		</div>
	)

}

export default FirstScreen;